import {
  useLazyQuery,
  useMutation,
  useQuery,
  useSubscription,
} from "@apollo/client";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  QUERY_PERFORMANCE_METRICS,
  SUBSCRIBE_NEW_PERFORMANCE_METRICS_UPDATE,
  SUBSCRIBE_NEW_PERFORMANCE_METRICS_APPEND,
  QUERY_AVAILABLE_PERFORMANCE_METRICS_SEASONS,
  QUERY_AVAILABLE_PERFORMANCE_METRICS_EVENTS,
  QUERY_PERFORMANCE_METRICS_FOR_EVENT,
  MUTATE_SAVE_PERFORMANCE_METRICS_DATA,
} from "../queries/performanceMetricsQueries";
import {
  mergePerformanceMetricsUpdate,
  setLoadingGraphs,
  setPerformanceMetricsData,
} from "../../../state/performanceMetricsReducer";

export function QueryPerformanceMetricsData() {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(QUERY_PERFORMANCE_METRICS);
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    dispatch(setLoadingGraphs(loading));
  }, [dispatch, loading]);
  useEffect(() => {
    if (data) {
      dispatch(setPerformanceMetricsData(data.getPerformanceMetricsData));
    }
  }, [dispatch, data, error]);
}

export function SubscribePerformanceMetricsData() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_NEW_PERFORMANCE_METRICS_UPDATE, {
    onData: (x) => {
      const update = x.data.data.newPerformanceMetricsUpdate;
      dispatch(setPerformanceMetricsData(update));
    },
  });
  if (error) {
    console.log("Subscription error:", error);
  }
}

export function SubscribeAppendPerformanceMetricsData() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_NEW_PERFORMANCE_METRICS_APPEND, {
    onData: (x) => {
      const update = x.data.data.newPerformanceMetricsAppend;
      dispatch(mergePerformanceMetricsUpdate(update));
    },
  });
  if (error) {
    console.log("Subscription error:", error);
  }
}

export function QueryAvailablePerformanceMetricsSeasons() {
  const [querySeasons, { data, loading, error }] = useLazyQuery(
    QUERY_AVAILABLE_PERFORMANCE_METRICS_SEASONS,
  );
  if (error) {
    console.log(error);
  }
  return {
    querySeasons: () => querySeasons(),
    seasons: data?.getAvailablePerformanceMetricsSeasons,
    loading,
    error,
  };
}

export function QueryAvailablePerformanceMetricsEvents() {
  const [queryEvents, { data, loading, error }] = useLazyQuery(
    QUERY_AVAILABLE_PERFORMANCE_METRICS_EVENTS,
  );
  if (error) {
    console.log(error);
  }
  return {
    queryEvents: (season: number) => queryEvents({ variables: { season } }),
    events: data?.getAvailablePerformanceMetricsEvents,
    loading,
    error,
  };
}

export function QueryPerformanceMetricsForEvent() {
  const [queryPerformanceMetricsForEvent, { loading, error }] = useLazyQuery(
    QUERY_PERFORMANCE_METRICS_FOR_EVENT,
  );
  if (error) {
    console.log(error);
  }
  return {
    queryPerformanceMetricsForEvent: (event: string) =>
      queryPerformanceMetricsForEvent({ variables: { event } }),
    loading,
    error,
  };
}

export function MutateSavePerformanceMetricsData() {
  const [savePerformanceMetricsData] = useMutation(
    MUTATE_SAVE_PERFORMANCE_METRICS_DATA,
  );
  return savePerformanceMetricsData;
}
